import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchEmailBackfills } from "./api"

// Backfills run for minutes to hours, so a 30s poll keeps the lifecycle stage fresh.
// Most users have none, so polling stops on an empty response and resumes via
// refetch-on-focus/remount.
const REFETCH_INTERVAL = 30_000

export function useEmailBackfills() {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["email_backfills"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchEmailBackfills(context)
    },
    refetchInterval: (query) => (query.state.data?.length ? REFETCH_INTERVAL : false),
  })
}
